var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypePaymentMethodIconSizelWeightfilled = function SvgTypePaymentMethodIconSizelWeightfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED0006",
    fillRule: "evenodd",
    d: "M16.239 22.44a9.07 9.07 0 0 1-5.865 2.133c-4.993 0-9.04-4-9.04-8.933 0-4.934 4.047-8.933 9.04-8.933A9.07 9.07 0 0 1 16.24 8.84a9.07 9.07 0 0 1 5.864-2.134c4.993 0 9.041 4 9.041 8.933 0 4.934-4.048 8.933-9.04 8.933a9.07 9.07 0 0 1-5.865-2.134",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A000",
    fillRule: "evenodd",
    d: "M16.239 22.44a8.87 8.87 0 0 0 3.176-6.8 8.87 8.87 0 0 0-3.176-6.8 9.07 9.07 0 0 1 5.864-2.133c4.993 0 9.04 4 9.04 8.933 0 4.934-4.047 8.933-9.04 8.933a9.07 9.07 0 0 1-5.864-2.134",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E00",
    fillRule: "evenodd",
    d: "M16.239 22.44a8.87 8.87 0 0 0 3.176-6.8 8.87 8.87 0 0 0-3.176-6.8 8.87 8.87 0 0 0-3.177 6.8 8.87 8.87 0 0 0 3.177 6.8",
    clipRule: "evenodd"
  })));
};
export default SvgTypePaymentMethodIconSizelWeightfilled;